var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseBlowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 15.9997V6.85561H15.6673V6.17827L8.00065 0.420898L0.333984 6.17827V6.85561H2.00065V15.9997",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.55057H1.33333C2.41518 8.55057 3.46785 8.19406 4.33333 7.53456C5.19881 6.87506 6.25148 6.51855 7.33333 6.51855",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6152H1.33333C2.41518 12.6152 3.46785 12.9717 4.33333 13.6312C5.19881 14.2907 6.25148 14.6472 7.33333 14.6472",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.90585H1.625C2.53801 9.90584 3.44757 9.7921 4.33333 9.56719C5.21906 9.34206 6.12865 9.22831 7.04167 9.22852H7.33333",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.2607H1.625C2.53802 11.2605 3.44761 11.3743 4.33333 11.5994C5.2191 11.8243 6.12866 11.9381 7.04167 11.9381H7.33333",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 8.55057H14.666C13.5842 8.55057 12.5315 8.19406 11.666 7.53456C10.8005 6.87506 9.74787 6.51855 8.66602 6.51855",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 12.6152H14.666C13.5842 12.6152 12.5315 12.9717 11.666 13.6312C10.8005 14.2907 9.74787 14.6472 8.66602 14.6472",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 9.90585H14.3743C13.4613 9.90584 12.5518 9.7921 11.666 9.56719C10.7803 9.34206 9.8707 9.22831 8.95768 9.22852H8.66602",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 11.2607H14.3743C13.4613 11.2605 12.5517 11.3743 11.666 11.5994C10.7803 11.8243 9.87069 11.9381 8.95768 11.9381H8.66602",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 5.50098L7.33268 6.51698L6.66602 7.53299",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.20996L7.33268 9.22597L6.66602 10.242",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 10.9199L7.33268 11.9359L6.66602 12.9519",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 13.6289L7.33268 14.6449L6.66602 15.6609",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBlowing);
export default __webpack_public_path__ + "static/media/houseBlowing.ccadf011.svg";
export { ForwardRef as ReactComponent };